import { render, staticRenderFns } from "./WorkItemsTable.vue?vue&type=template&id=b84235d8&scoped=true"
import script from "./WorkItemsTable.vue?vue&type=script&lang=js"
export * from "./WorkItemsTable.vue?vue&type=script&lang=js"
import style0 from "./WorkItemsTable.vue?vue&type=style&index=0&id=b84235d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84235d8",
  null
  
)

export default component.exports